/* eslint-disable */
import * as registry from '../registry.js'
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Files_File_CountInputs */

const en_files_file_count = /** @type {(inputs: Files_File_CountInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("en", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} file`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} files`);
	return /** @type {LocalizedString} */ ("files_file_count");
};

const es_files_file_count = /** @type {(inputs: Files_File_CountInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("es", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} archivo`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} archivos`);
	return /** @type {LocalizedString} */ ("files_file_count");
};

/**
* | countPlural | output |
* | --- | --- |
* | "one" | "{count} file" |
* | "other" | "{count} files" |
*
* @param {Files_File_CountInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const files_file_count = /** @type {((inputs: Files_File_CountInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Files_File_CountInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_files_file_count(inputs)
	return en_files_file_count(inputs)
});